import React from 'react';
import { ReactComponent as CompanyLogo } from 'assets/svg/Hyvid_brand_logo.svg';
import CompanyNameImage from 'assets/img/logo/Hyvid_One_Logo_1.png';
// import { ReactComponent as CompanyLogo } from 'assets/svg/intsamis_logo.svg';
// import CompanyNameImage from 'assets/img/logo/intsamis_logo_dark.png';

const ApplicationName = ({logoOnly, extra, logoClass, companyNameClass, ...props}) => {

  	return (    
	    <div className={`${extra}`}>
		    <div className="p-2">
				<CompanyLogo className={`company-logo ${logoClass}`}/>
			</div>
			<div className={`company-name ${logoOnly ? 'hidden': ''} ${companyNameClass}`}>
				<img src={CompanyNameImage} alt="HyvidOne" style={{'maxWidth':'70%'}}/>
			</div>
	  	</div>
  	);
};

export default ApplicationName;